(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["iprintop-print-configurator"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('iprintop-print-configurator')) {
    customElements.define('iprintop-print-configurator', class extends HTMLElement {
      connectedCallback() {
        if (this.listenerController) return;
        this.listenerController = new AbortController();
        this.hiddenStandardNodes = new Set();
        this.disabledStandardButtons = new Map();
        this.mode = 'standard';
        this.scope = document.getElementById(`MainProduct-${this.dataset.sectionId}`);
        if (!this.scope) return;
        const signal = this.listenerController.signal;
        try {
          this.nativeOptions = JSON.parse(this.querySelector('[data-print-native-options]').textContent).options;
        } catch {
          return;
        }
        this.quoteForm = this.querySelector('[data-specification-form]');
        this.quotePanel = this.querySelector('[data-quote-panel]');
        this.standardIntro = this.querySelector('[data-standard-intro]');
        this.standardSelection = this.querySelector('[data-standard-selection]');
        this.unavailableNotice = this.querySelector('[data-native-unavailable]');
        this.fallback = this.querySelector('[data-quote-fallback]');
        if (this.quoteForm) {
          try {
            this.configuration = JSON.parse(this.querySelector('[data-print-configuration]').textContent);
            this.strings = JSON.parse(this.querySelector('[data-print-strings]').textContent);
            this.renderFields();
            this.querySelector('[data-print-mode="quote"]').disabled = false;
            this.querySelectorAll('[data-print-mode]').forEach((button) => {
              button.addEventListener('click', () => this.setMode(button.dataset.printMode), { signal });
            });
            this.fallback.hidden = true;
          } catch {
            this.quoteForm = null;
          }
        }
        this.scope.addEventListener('submit', (event) => {
          if (this.mode === 'quote' && event.target.id === `product-form-${this.dataset.sectionId}`) {
            event.preventDefault();
            event.stopImmediatePropagation();
            this.quoteForm.querySelector('button[type="submit"]')?.focus();
          }
        }, { capture: true, signal });
        this.quoteForm?.addEventListener('change', () => this.syncDependencies(), { signal });
        this.scope.addEventListener('change', (event) => {
          if (event.target.closest('variant-selects')) this.syncNativeSummary();
        }, { signal });
        this.observer = new MutationObserver(() => {
          this.sortNativeQuantityOptions();
          if (this.mode === 'quote') this.guardStandardPurchase();
          else this.syncNativeSummary();
        });
        this.observer.observe(this.scope, { childList: true, subtree: true });
        this.syncDependencies();
        this.sortNativeQuantityOptions();
        this.syncNativeSummary();
      }
      sortNativeQuantityOptions() {
        const picker = this.scope.querySelector('variant-selects');
        if (!picker) return;
        const selects = Array.from(picker.querySelectorAll('select'));
        this.nativeOptions.filter((option) => /^(quantity|cards per pack)$/i.test(option.name)).forEach((option) => {
          const selectId = `Option-${this.dataset.sectionId}-${Number(option.position) - 1}`;
          const select = selects.find((item) => item.id === selectId && item.name === `options[${option.name}]`);
          if (!select || select.multiple) return;
          const nodes = Array.from(select.options);
          const quantities = nodes.map((node) => {
            const value = node.value.trim();
            if (!/^(?:[0-9]+|[0-9]{1,3}(?:,[0-9]{3})+)$/.test(value)) return null;
            const quantity = Number(value.replace(/,/g, ''));
            return Number.isSafeInteger(quantity) && quantity > 0 ? quantity : null;
          });
          if (quantities.some((quantity) => quantity === null)) return;
          const sorted = nodes.map((node, index) => ({ node, quantity: quantities[index] })).sort((a, b) => a.quantity - b.quantity).map((item) => item.node);
          if (nodes.every((node, index) => node === sorted[index])) return;
          const selectedValue = select.value;
          select.append(...sorted);
          select.value = selectedValue;
        });
      }
      renderFields() {
        const container = this.querySelector('[data-configuration-fields]');
        const fragment = document.createDocumentFragment();
        this.configuration.fields.forEach((field) => {
          const wrapper = document.createElement('div');
          wrapper.className = 'ipt-print-config__field';
          const id = `PrintSpec-${this.dataset.sectionId}-${field.key}`;
          const label = document.createElement('label');
          label.htmlFor = id;
          label.textContent = this.strings.labels[field.label || field.key] || field.key;
          const input = document.createElement(field.kind === 'select' ? 'select' : 'input');
          input.name = field.key;
          input.id = id;
          input.dataset.specField = field.key;
          if (field.kind === 'select') {
            input.append(new Option(this.strings.advise, ''));
            field.choices.forEach((choice) => input.append(new Option(choice, choice)));
          } else {
            input.type = field.kind === 'number' ? 'number' : 'text';
            if (field.kind === 'number') {
              input.min = '1';
              input.step = '1';
              input.inputMode = 'numeric';
            } else {
              input.maxLength = 180;
            }
            let choices = field.choices || [];
            if (field.key === 'quantity') {
              const nativeQuantity = this.nativeOptions.find((option) => /quantity|per pack/i.test(option.name));
              choices = nativeQuantity?.values || [];
              input.required = true;
            }
            if (choices.length || field.key === 'weight') {
              const list = document.createElement('datalist');
              list.id = `${id}-choices`;
              choices.forEach((choice) => list.append(new Option(String(choice), String(choice))));
              input.setAttribute('list', list.id);
              wrapper.append(list);
            }
            if (field.key !== 'quantity' && field.key !== 'designs') input.placeholder = this.strings.advise;
          }
          wrapper.prepend(label);
          wrapper.append(input);
          const hintKey = field.hint;
          if (hintKey && this.strings[hintKey]) {
            const hint = document.createElement('p');
            hint.className = 'ipt-print-config__hint';
            hint.id = `${id}-hint`;
            hint.textContent = this.strings[hintKey];
            input.setAttribute('aria-describedby', hint.id);
            wrapper.append(hint);
          }
          fragment.append(wrapper);
        });
        container.replaceChildren(fragment);
        this.querySelector('[data-product-guidance]').textContent = this.strings.guidance[this.configuration.guidance] || this.strings.guidance.paper;
      }
      setMode(mode) {
        if (!this.quoteForm || !this.quotePanel) return;
        this.mode = mode === 'quote' ? 'quote' : 'standard';
        const quoting = this.mode === 'quote';
        this.querySelectorAll('[data-print-mode]').forEach((button) => button.setAttribute('aria-pressed', String(button.dataset.printMode === this.mode)));
        this.quotePanel.hidden = !quoting;
        this.standardIntro.hidden = quoting;
        this.standardSelection.hidden = quoting;
        this.unavailableNotice.hidden = true;
        if (quoting) {
          this.prefillQuantity();
          this.guardStandardPurchase();
        } else {
          this.restoreStandardPurchase();
          this.syncNativeSummary();
        }
      }
      prefillQuantity() {
        const field = this.quoteForm.elements.namedItem('quantity');
        if (!field || field.value) return;
        const nativeQuantity = this.nativeOptions.find((option) => /quantity|per pack/i.test(option.name));
        if (!nativeQuantity) return;
        const picker = this.scope.querySelector('variant-selects');
        const select = picker ? Array.from(picker.querySelectorAll('select')).find((item) => item.name === `options[${nativeQuantity.name}]`) : null;
        const checked = picker ? Array.from(picker.querySelectorAll('input:checked')).find((item) => item.name === nativeQuantity.name || item.name === `options[${nativeQuantity.name}]`) : null;
        const value = String(select?.value || checked?.value || nativeQuantity.selected || '').replace(/,/g, '');
        if (/^\d+$/.test(value)) field.value = value;
      }
      syncNativeSummary() {
        const picker = this.scope.querySelector('variant-selects');
        const text = this.nativeOptions.map((option) => {
          const select = picker ? Array.from(picker.querySelectorAll('select')).find((item) => item.name === `options[${option.name}]`) : null;
          const checked = picker ? Array.from(picker.querySelectorAll('input:checked')).find((item) => item.name === option.name || item.name === `options[${option.name}]`) : null;
          return `${option.name}: ${select?.value || checked?.value || option.selected || ''}`;
        }).join(' · ');
        const output = this.querySelector('[data-native-selection]');
        if (output && output.textContent !== text) output.textContent = text;
        this.standardSelection.hidden = this.mode === 'quote';
        const selectedVariantData = picker?.querySelector('[data-selected-variant]');
        let unavailable = false;
        if (selectedVariantData) {
          try {
            unavailable = !JSON.parse(selectedVariantData.textContent);
          } catch {
            unavailable = false;
          }
        }
        this.unavailableNotice.hidden = this.mode === 'quote' || !unavailable;
      }
      guardStandardPurchase() {
        const sectionId = this.dataset.sectionId;
        const nodes = [
          document.getElementById(`price-${sectionId}`),
          document.getElementById(`Quantity-Form-${sectionId}`),
          document.getElementById(`product-form-installment-${sectionId}`),
          this.scope.querySelector('variant-selects'),
          document.getElementById(`product-form-${sectionId}`)?.closest('product-form'),
          ...this.scope.querySelectorAll('.product__tax, .shopify-payment-button')
        ];
        nodes.filter((node) => node && this.scope.contains(node)).forEach((node) => {
          if (!node.classList.contains('ipt-print-standard-hidden')) {
            node.classList.add('ipt-print-standard-hidden');
            this.hiddenStandardNodes.add(node);
          }
        });
        const form = document.getElementById(`product-form-${sectionId}`);
        if (form && this.scope.contains(form)) {
          form.querySelectorAll('button[type="submit"], input[type="submit"]').forEach((button) => {
            if (!this.disabledStandardButtons.has(button)) this.disabledStandardButtons.set(button, button.disabled);
            button.disabled = true;
          });
        }
      }
      restoreStandardPurchase() {
        this.hiddenStandardNodes?.forEach((node) => node.classList.remove('ipt-print-standard-hidden'));
        this.hiddenStandardNodes?.clear();
        this.disabledStandardButtons?.forEach((disabled, button) => { button.disabled = disabled; });
        this.disabledStandardButtons?.clear();
      }
      syncDependencies() {
        const fields = this.quoteForm?.elements;
        if (!fields) return;
        const material = fields.namedItem('material');
        const weight = fields.namedItem('weight');
        const stockGroups = this.configuration.stockGroups;
        if (material && weight && stockGroups) {
          const group = stockGroups.find((item) => item.material === material.value);
          if (weight.dataset.stock !== material.value) {
            weight.replaceChildren(new Option(this.strings.advise, ''), ...(group?.weights || []).map((value) => new Option(value, value)));
            weight.value = group?.weights?.length === 1 ? group.weights[0] : '';
            weight.dataset.stock = material.value;
          }
        }
        if (this.configuration.rules?.includes('business_cards')) {
          const lamination = fields.namedItem('lamination');
          const embellishment = fields.namedItem('embellishment');
          const corners = fields.namedItem('corners');
          if (lamination) {
            Array.from(lamination.options).forEach((option) => { option.disabled = (material?.value === 'Uncoated' && option.value !== '' && option.value !== 'No lamination') || (corners?.value === 'Rounded' && option.value === 'Gloss'); });
            if (lamination.selectedOptions[0]?.disabled) lamination.value = 'No lamination';
          }
          if (embellishment) {
            const enabled = material?.value === 'Silk' && ['Matt', 'Velvet / soft touch'].includes(lamination?.value);
            Array.from(embellishment.options).forEach((option) => { option.disabled = !enabled && option.value !== '' && option.value !== 'None'; });
            if (embellishment.selectedOptions[0]?.disabled) embellishment.value = 'None';
          }
        }
        if (this.configuration.rules?.includes('label_stock') && material?.value === 'White polypropylene' && weight) {
          const format = fields.namedItem('format')?.value;
          const mappedWeight = format === 'Reeled labels' ? '40 gsm' : format === 'Sticker sheets' ? '55 gsm' : '';
          if (mappedWeight) weight.value = mappedWeight;
        }
        if (this.configuration.rules?.includes('flyer_finishing')) {
          const lamination = fields.namedItem('lamination');
          const embellishment = fields.namedItem('embellishment');
          const lightStock = (material?.value === 'Silk' && weight?.value === '150 gsm') || (material?.value === 'Uncoated' && weight?.value === '170 gsm') || (material?.value === 'Gloss' && weight?.value === '130 gsm');
          if (lamination) {
            Array.from(lamination.options).forEach((option) => { option.disabled = lightStock && option.value !== '' && option.value !== 'No lamination'; });
            if (lamination.selectedOptions[0]?.disabled) lamination.value = 'No lamination';
          }
          if (embellishment) {
            const foilAvailable = material?.value === 'Silk' && ['250 gsm', '350 gsm'].includes(weight?.value) && lamination?.value === 'Matt';
            Array.from(embellishment.options).forEach((option) => { option.disabled = (lightStock && option.value !== '' && option.value !== 'None') || (/foil/i.test(option.value) && !foilAvailable); });
            if (embellishment.selectedOptions[0]?.disabled) embellishment.value = 'None';
          }
        }
        if (this.configuration.rules?.includes('roller_base')) {
          const base = fields.namedItem('base');
          const size = fields.namedItem('size');
          if (base) {
            Array.from(base.options).forEach((option) => { option.disabled = option.value === 'Premium' && !/^(800|1000)\s*[×x]/i.test(size?.value || ''); });
            if (base.selectedOptions[0]?.disabled) base.value = 'Standard';
          }
        }
      }
      disconnectedCallback() {
        this.observer?.disconnect();
        this.restoreStandardPurchase();
        this.listenerController?.abort();
        this.listenerController = null;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
